import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '@usucampeao/utils-frontend';
import { CadastroStatusModule } from 'libs/ui-mobile/src/lib/components/cadastro-ficha-status/cadastro-status.module';
import { FooterModule, HeaderModule, MenuItemModule, UploadFotoImovelModule } from '../../../../components';
import { ImoveisFichaComponent } from './imoveis-ficha.component';

@NgModule({
  declarations: [
    ImoveisFichaComponent
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,

    // components
    CadastroStatusModule,
    FooterModule,
    HeaderModule,
    MenuItemModule,
    UploadFotoImovelModule,

    // others
    PipesModule,
  ],
  exports: [
    ImoveisFichaComponent
  ]
})
export class ImoveisFichaModule { }
